import { render } from "./SupervisorHome.vue?vue&type=template&id=97ca1c12&scoped=true"
import script from "./SupervisorHome.vue?vue&type=script&lang=js"
export * from "./SupervisorHome.vue?vue&type=script&lang=js"

import "./SupervisorHome.vue?vue&type=style&index=0&id=97ca1c12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ca1c12"]])

export default __exports__